import { useState } from 'react';
import { Plus } from 'lucide-react';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import {
  SectionLayout,
  SectionLayoutSkeleton,
} from '@/components/ui/SectionLayout';
import NoItems from '@/components/ui/NoItems.tsx';
import BankAccountsList from '@/features/dashboard/paymentConfig/components/BankAccountsList.tsx';
import CreateBankAccountModal from '@/features/dashboard/paymentConfig/components/CreateBankAccountModal.tsx';
import useGetBankAccounts from '@/features/dashboard/paymentConfig/hooks/useGetBankAccounts.ts';

const BankAccountsSection = () => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const { data: bankAccounts, isLoading } = useGetBankAccounts();

  if (isLoading) {
    return <SectionLayoutSkeleton rows={3} />;
  }

  const accounts = bankAccounts ?? [];

  return (
    <>
      <SectionLayout
        title="Płatności przelewem bankowym"
        description="Konto podpowiadane uczestnikowi po wyborze przelewu. Dokładnie jedno konto w każdej walucie może być domyślne."
      >
        {accounts.length > 0 ? (
          <div className="space-y-3">
            <BankAccountsList bankAccounts={accounts} />
            <ActionButton
              tone="outline"
              size="toolbar"
              onClick={() => setIsCreateModalOpen(true)}
            >
              <Plus />
              Dodaj konto
            </ActionButton>
          </div>
        ) : (
          <NoItems
            title="Brak kont bankowych"
            description="Dodaj konto, aby przelew był dostępny jako forma płatności."
          >
            <ActionButton
              tone="outline"
              size="toolbar"
              onClick={() => setIsCreateModalOpen(true)}
            >
              Dodaj konto
            </ActionButton>
          </NoItems>
        )}
      </SectionLayout>
      {isCreateModalOpen && (
        <CreateBankAccountModal onClose={() => setIsCreateModalOpen(false)} />
      )}
    </>
  );
};

export default BankAccountsSection;
